import React from 'react';
import { HeroSection } from './components/HeroSection';
import { QuickTestimonials } from './components/QuickTestimonials';
import { IdentificationSection } from './components/IdentificationSection';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatYouLearn } from './components/WhatYouLearn';
import { ModulesSection } from './components/ModulesSection';
import { PreviewSection } from './components/PreviewSection';
import { BonusSection } from './components/BonusSection';
import { ForWhomSection } from './components/ForWhomSection';
import { TransformationSection } from './components/TransformationSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostSection } from './components/CostSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-bg text-ink" data-id="element-0">
      <HeroSection data-id="element-1" />
      <QuickTestimonials data-id="element-2" />
      <IdentificationSection data-id="element-3" />
      <ProductPresentation data-id="element-4" />
      <WhatYouLearn data-id="element-5" />
      <ModulesSection data-id="element-6" />
      <PreviewSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <ForWhomSection data-id="element-9" />
      <TransformationSection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <FAQSection data-id="element-14" />
      <CostSection data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}